"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Dollar.css");

var _styles = {
  "number": "Dollar__number___2sE6j",
  "h1": "Dollar__h1___2vQRB",
  "h2": "Dollar__h2___1bjDc",
  "h3": "Dollar__h3___yxPSl",
  "h4": "Dollar__h4___2Yvy2",
  "h5": "Dollar__h5___nwyTo",
  "span": "Dollar__span___1oFAU",
  "regular": "Dollar__regular___3gATs",
  "medium": "Dollar__medium___9cuHt"
};

const styles = _bind.default.bind(_styles);

const Dollar = ({
  className,
  variant = 'regular',
  tag: Tag = 'h1',
  color,
  value,
  parentheses,
  dataTestId,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('number', variant, Tag), className);
  return _react.default.createElement(Tag, {
    className: composed_classname,
    "data-testid": dataTestId,
    style: {
      color
    },
    ...props
  }, parentheses && '(', _react.default.createElement("span", null, "$"), _react.default.createElement("span", {
    "data-testid": dataTestId && `${dataTestId}-value`
  }, value), parentheses && ')');
};

var _default = Dollar;
exports.default = _default;